import { tns } from 'tiny-slider/src/tiny-slider'

export default () => {

	const els = [...document.querySelectorAll('.text-carousel__row')]
	els.map(el => {

		const carouselEl = el.querySelector('.text-carousel')
		if (!carouselEl) return null



		// remove classes for setting pagewidth before carousel inits
		//carouselEl.classList.remove('grid')
		//carouselEl.classList.remove('page-width')

		return tns({
			container: carouselEl,
			items: 1.2,
			controls : false,
			controlsPosition: 'bottom',
			nav: true,
			navPosition: 'bottom',
			touch: true,
			mouseDrag: true,
			loop: false,
			autoplay: true,
			speed: 700,
			autoplayTimeout: 9000,
			autoplayButtonOutput: false,
			useLocalStorage: false,
			responsive : {
				450 : { items : 1  },
				608 : { items : 2 },
				880 : { items : 3 },
			}
		})
	})
}


